<template>
  <section class="login">
    <article class="panel">
      <p class="eyebrow">Acesso</p>
      <h2>Entrar no painel</h2>
      <p class="muted">Use as credenciais de administrador para editar a {{ assistantName }} e as integrações.</p>
      <form class="form" @submit.prevent="submit">
        <label>
          Usuário
          <input v-model="username" autocomplete="username" required />
        </label>
        <label>
          Senha
          <input v-model="password" type="password" autocomplete="current-password" required />
        </label>
        <button type="submit" :disabled="loading">{{ loading ? 'Entrando…' : 'Entrar' }}</button>
      </form>
      <p class="muted error" v-if="error">{{ error }}</p>
    </article>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { assistantName } from '../assistant-name';
import { login } from '../auth';

const router = useRouter();
const route = useRoute();
const username = ref('admin');
const password = ref('');
const loading = ref(false);
const error = ref('');

async function submit() {
  loading.value = true;
  error.value = '';
  const result = await login(username.value, password.value);
  loading.value = false;
  if (!result.ok) {
    error.value =
      result.error === 'invalid_credentials'
        ? 'Usuário ou senha inválidos.'
        : result.error === 'admin_password_not_configured'
          ? 'Senha admin ainda não configurada no servidor (ADMIN_PASSWORD_HASH).'
          : result.error;
    return;
  }
  const redirect = typeof route.query.redirect === 'string' ? route.query.redirect : '/';
  await router.replace(redirect);
}
</script>
